<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش پیام ها</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-select color="black" v-model="order" label="نوع ترتیب پیام ها را انتخاب کنید" :items="orderItems"
                      item-text="name" @change="getMessages"></v-select>
          </v-col>
          <v-col cols="3">
            <v-text-field v-model="needle" hint="شامل عنوان و محتوا"
                          label="در محتوای پیام جستجو کنید." color="black">
            </v-text-field>
          </v-col>
          <v-col cols="2">
            <v-btn @click="getMessages()" class="mt-4" elevation="0" color="info"
                   style="letter-spacing: normal!important">
              جستجو
            </v-btn>
          </v-col>
          <v-col cols="4" class="text-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="hover-link mx-1"
                        color="teal"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/messages/setting')">mdi-cog
                </v-icon>
              </template>
              <span class="tooltip-text">تنظیمات پیام ها</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-large class="hover-link mx-1"
                        color="success"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/messages/create')">mdi-plus
                </v-icon>
              </template>
              <span class="tooltip-text">ارسال پیام جدید</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                :single-expand="singleExpand"
                :expanded.sync="expanded"
                item-key="id"
                show-expand
                :headers="headers"
                :items="messages.data"
                :items-per-page="10"
                disable-sort
                expand-icon="mdi-chevron-up"
                hide-default-footer>
              <template v-slot:top>
                <v-toolbar flat>
                  <v-spacer></v-spacer>
                  <v-switch
                      v-model="singleExpand"
                      label="فقط یک سطر باز شود."
                      class="mt-2"
                  ></v-switch>
                </v-toolbar>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-row>
                    <v-col cols="4">مربی :
                      {{ item.instructor_name }}
                    </v-col>
                    <v-col cols="4">هنرجو :
                      {{ item.student_name }}
                    </v-col>
                    <v-col cols="4">مدیر :
                      {{ item.admin_name }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">محتوا :
                      {{ item.content }}
                    </v-col>
                  </v-row>
                </td>
              </template>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-icon class="mx-1" color="success" @click="reply(item.id)">mdi-reply</v-icon>
                <v-icon class="mx-1" color="purple" @click="$router.push('/messages/edit/'+item.id)">mdi-pen
                </v-icon>
                <v-icon class="mx-1" color="error" @click="destroy(item.id)">mdi-trash-can-outline</v-icon>
              </template>
              <template
                  v-slot:[`item.has_reply`]="{ item }">
                <span v-if="item.has_reply">
                  <v-icon color="success">mdi-check</v-icon>
                </span>
                <span v-else>
                  <v-icon color="error">mdi-close</v-icon>
                </span>
              </template>
              <template
                  v-slot:[`item.seen`]="{ item }">
                <span v-if="item.seen">
                  <v-icon color="success">mdi-check</v-icon>
                </span>
                <span v-else>
                  <v-icon color="error">mdi-close</v-icon>
                </span>
              </template>
              <template
                  v-slot:[`item.attachment_type`]="{ item }">
                <span v-if="item.attachment_type === 'zip'">
                  فایل فشرده
                </span>
                <span v-else-if="item.attachment_type === 'audio'">
                  صوتی
                </span>
                <span v-else-if="item.attachment_type === 'video'">
                  ویدیو
                </span>
                <span v-else-if="item.attachment_type === 'pdf'">
                  پی دی اف
                </span>
                <span v-else-if="item.attachment_type === 'image'">
                  تصویر
                </span>
              </template>
              <template
                  v-slot:[`item.select`]="{ item }">
                <v-checkbox color="black" v-model="selectedMessageIds[item.id]">
                </v-checkbox>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12" class="text-left">
            <v-btn @click="destroyMulti" color="error" style="letter-spacing: normal!important">
              پاک کردن گروهی
            </v-btn>
          </v-col>
          <v-col cols="12" class="text-left">
            <v-pagination
                color="#696CFF"
                v-model="messages.current_page"
                :length="messages.last_page"
                circle
                @input="getMessages"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "MessageIndex",
  data() {
    return {
      expanded: [],
      singleExpand: false,
      selectedMessageIds: [],
      loading: true,
      needle: null,
      orderItems: [
        {name: 'بر اساس عنوان', value: 'title'},
        {name: 'بر اساس اولویت', value: 'priority'},
        {name: 'بر اساس بخش', value: 'section'},
        {name: 'بر اساس نوع ضمیمه', value: 'attachment_type'},
        {name: 'بر اساس وضعیت', value: 'status'},
        {name: 'بر اساس تاریخ ساخت', value: 'created_at'},
      ],
      order: 'created_at',
      messages: {
        current_page: 1
      },
      headers: [
        {text: 'شناسه', value: 'id', align: 'center', width: '2%'},
        {text: 'عنوان', value: 'title', align: 'center', width: '10%'},
        {text: 'نوع ضمیمه', value: 'attachment_type', align: 'center', width: '10%'},
        {text: 'فرستاده شده توسط', value: 'sent_by', align: 'center', width: '10%'},
        {text: 'وضعیت مشاهده', value: 'seen', align: 'center', width: '10%'},
        {text: 'مشاهده شده در', value: 'seen_at_fa', align: 'center', width: '10%'},
        {text: 'منقضی شود در', value: 'expire_at_fa', align: 'center', width: '10%'},
        {text: 'پاسخ داده شده؟', value: 'has_reply', align: 'center', width: '10%'},
        {text: 'تاریخ ساخت', value: 'created_at_fa', align: 'center'},
        {text: 'عملیات', value: 'operation', align: 'center', width: '10%'},
        {text: 'انتخاب', value: 'select', align: 'right', width: '10%'},
      ],
    }
  },
  mounted() {
    this.getMessages()
  },
  methods: {
    getMessages() {
      let url = '/message/crud/index?page=' + this.messages.current_page ?? 1
      url = url + '&order=' + this.order
      if (this.needle) {
        url = url + '&needle=' + this.needle
      }
      window.axios.get(url).then((res) => {
        this.messages = res.data.data
        this.messages.data.forEach((item) => {
          this.$set(this.selectedMessageIds, item.id, true)
        })
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    destroy(messageId) {
      window.axios.delete('message/crud/delete/' + messageId).then(() => {
        this.getMessages()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    destroyMulti() {
      window.axios.post('message/crud/multiple/delete', {
        ids: this.selectedMessageIds
      }).then(() => {
        this.getMessages()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    reply(itemId) {
      this.$router.push('/messages/reply/' + itemId)
    }
  }
}
</script>

<style scoped>
.color-box {
  width: 40px !important;
  height: 40px !important;
  border-radius: 8px !important;
}
</style>